import { render, staticRenderFns } from "./RatesTable.vue?vue&type=template&id=71c2e762&scoped=true"
import script from "./RatesTable.vue?vue&type=script&lang=js"
export * from "./RatesTable.vue?vue&type=script&lang=js"
import style0 from "./RatesTable.vue?vue&type=style&index=0&id=71c2e762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c2e762",
  null
  
)

export default component.exports